import { useMemo } from "react";
import { useMessageThreads } from "@/lib/messagingQueries";
import { useTeamMembers } from "@/lib/teamRecordQueries";
import { ThreadView } from "@/pages/RehearsalRoom/messages/ThreadView";

/**
 * Clients Restructure — Team 360 -> Messages. Reuses the EXACT same
 * thread/composer/AudienceGate mechanism as MessagesPage.jsx/
 * ThreadView.jsx — restricted to this Workspace's ONE `workspace_shared`
 * (Team & Coach) thread, never a member-private thread.
 */
export default function MessagesTab({ workspaceId }) {
  const { data, isPending } = useMessageThreads(workspaceId);
  const { data: membersData } = useTeamMembers(workspaceId);
  const teamThread = useMemo(() => (data?.items || []).find((t) => t.visibility_scope === "workspace_shared"), [data]);
  const teamMembers = (membersData?.items || []).map((m) => ({ membership_id: m.member_id, display_name: m.name }));

  if (isPending) return <p className="text-sm text-ink-soft" data-testid="team-messages-loading">Loading team conversation…</p>;
  if (!teamThread) return <p className="text-sm text-ink-soft" data-testid="team-messages-empty">No team conversation yet.</p>;

  return (
    <div data-testid="team-360-messages-tab">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-serif text-lg text-ink">Team & Coach conversation</h2>
        {teamThread.unread_count > 0 && (
          <span className="bg-terracotta text-paper text-[10px] font-semibold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1" data-testid="team-messages-unread-badge">
            {teamThread.unread_count}
          </span>
        )}
      </div>
      <div className="border border-ink/10 rounded-lg overflow-hidden bg-paper">
        <ThreadView
          workspaceId={workspaceId} threadId={teamThread.thread_id} isTeamWorkspace actorRole="coach" teamMembers={teamMembers}
          lockedAudienceSelection={{ action_type: "message", actor_role: "coach", choice: "whole_team", target_membership_ids: [] }}
        />
      </div>
    </div>
  );
}
